export default {    
    // 马来语2
    public:{
        subject: 'Subjek',
        author: 'Pengarang',
        select: 'Penapis',
        item:'Bilangan item',
        keywords: 'Kata kunci',
        load:'Memuatkan...',
        nodata:'Tiada data',
        close:'Dekat',
        all:'Semua',
        cancel:'Batal',
        traditionalChinese:'Cina tradisional',
        thai:'Thai',
        indonesian:'Indonesia',
        malay:'Melayu',
        filipino:'Filipina',

        successful:'Pendaftaran berjaya',
        loginTips: 'Sila log masuk ke akaun peribadi anda',
        loginSuccess: 'Login berjaya',
        library:'ChatAnswer Sistem rujukan AI Perpustakaan',
        fellows:'ChatFellows Sistem penemuan / petikan rakan sebaya intra-institusi',
        research:'ChatResearch Platform pertanyaan akademik yang cekap dan diperibadikan',
        language:'ChatLanguage Terjemahan pintar AI berbilang bahasa dan sistem pembacaan pruf tatabahasa',
        document:'ChatDocuments Alat penghuraian dokumen yang mendalam',
        data:'ChatData Alat penghuraian jadual data mendalam',
        other:'Lain',
        feedSuccess:'Maklum balas masalah berjaya!',
        codeTips:'Kod pengesahan telah dihantar, sila semak dengan teliti',
        overtime:'Permintaan tamat masa'	
    },
    header:{
        feedback:'Maklum balas',
        quit:'Berhenti',       
        personal:'Log masuk ke akaun peribadi',
      
        language:'Bahasa keluaran',
        username:'Nama pengguna',
        password:'Kata laluan',
        log:'Log masuk',
        noRegistered:'Tiada akaun didaftarkan',
        register:'Mendaftar',
        personalAccount:'Daftar akaun peribadi',
        accountUsername:'Akaun/Nama Pengguna',
        tips:'Sila masukkan akaun/nama pengguna',
        tipsPassword:'Sila masukkan kata laluan',
        confirmPassword:'Sahkan Kata Laluan',
        tipsConfirmPassword:'Sila sahkan kata laluan sekali lagi',
        email:'Mel',
        tipsEmail:'sila masukkan email anda',
        phone:'Nombor telefon',
        tipsPhone:'Sila masukkan nombor telefon',
        verificationCode:'Kod pengesahan telefon mudah alih',
        tipsVerificationCode:'Sila masukkan kod pengesahan telefon mudah alih',
        sendVerificationCode:'Dapatkan',
        back:'kembali',
        module:'Modul berfungsi',
        selectTip:'Sila pilih modul berfungsi dengan masalah',
        question:'Masalah Penerangan',
        screenshot:'Tangkapan skrin masalah',
        upload:'Klik untuk memuat naik',
        type:'Hanya menyokong muat naik format .jpg/.png',
        passwordTip:'Sila masukkan kata laluan 6-24 digit',
        enterAgain:'Sila masukkan kata laluan sekali lagi',
        inconsistent:'Kata laluan yang dimasukkan dua kali tidak konsisten',
        enterCode:'Sila masukkan kod pengesahan',
        emailTip:'Sila masukkan alamat e-mel yang betul',
        enterEmail:'Sila masukkan alamat e-mel',
        otherQuestion:'Adakah anda mempunyai soalan lain yang serupa dengan isu ini',
        example:'Sebagai contoh',
        bibliography:'bibliografi perpustakaan',
        logOut:'Adakah anda pasti mahu log keluar daripada akaun anda',
        sure:'Pasti',
        switching:'Berjaya bertukar kepada pelbagai bahasa',
        again:'Hantar semula selepas ',
        again2:'saat',
        hello:'Salam'
    },
    login:{
        log:'Log masuk',
        institutionalLogin:'Log masuk institusi',
        personalLogin:'Log masuk peribadi',
        accountRegistration:'Daftar akaun',
        retrievePassword:'Dapatkan semula kata laluan',
        usernameTip:'Sila masukkan nama pengguna organisasi anda',
        personal:'Sila masukkan nama pengguna peribadi anda',
        forget:'lupa kata laluan?',
        ipLog:'Log masuk IP',
        institutional:'Mekanisme',
        institutionalTip:'Sila pilih institusi',
        country:'Bangsa',
        countryTip:'Sila pilih negara',
        invitationCode:'Kod Jemputan',
        codeTip: 'Sila masukkan kod jemputan',
        newPass:'Kata laluan baharu',
        newPassTip:'Sila masukkan kata laluan baharu',
        elmaiCode:'Kod pengesahan e-mel',
        elmaiTip:'Sila masukkan kod pengesahan e-mel',
        resetting:'Menetapkan semula kata laluan',
        logTip: 'Nama pengguna organisasi tidak boleh kosong',

        truePhone:'Sila masukkan nombor telefon yang sah',
        successful:'Pendaftaran akaun berjaya, sila log masuk semula!',
        passwordReset:'Penetapan semula kata laluan berjaya, sila log masuk semula!',

        noteTitle:'Nota untuk mendapatkan kod pengesahan:',
        noteOne:'1. Untuk memastikan kod pengesahan dapat dihantar dalam masa dan tepat, kami mengesyorkan menggunakan pembekal perkhidmatan e-mel berikut: Gmail, Outkook, Yahoo;',
        noteTwo:'2. Disebabkan oleh mekanisme penapisan setiap pembekal perkhidmatan e-mel, kadangkala e-mel kod pengesahan mungkin tersilap dinilai sebagai spam atau e-mel tidak sah. Sila semak sama ada e-mel kod pengesahan berada dalam tong kitar semula spam.',
    },
    chatlibrary: {
        questionOne: 'Bertanya tentang isu peminjaman perpustakaan',
        questionTwo: 'Tanya tentang isu yang berkaitan dengan pangkalan data yang dibeli',
        questionThree:'Tanya tentang isu yang berkaitan dengan sumber digital perpustakaan',
        quickAccess:'Akses cepat',
        disclaimer: 'Penafian',
        further:'Soalan selanjutnya',
        goon:'Teruskan',
        statementOne: '1. Kandungan balasan ChatAnswer adalah berdasarkan jawapan kepada soalan lazim dan maklumat awam tentang sumber berkaitan. Kandungan sebenar tertakluk kepada maklumat rasmi yang diterbitkan oleh perpustakaan dan kandungan rasmi sumber sumber.',
        statementTwo: '2. Hasil terjemahan fungsi terjemahan adalah untuk rujukan sahaja. Platform tidak bertanggungjawab untuk sebarang kerugian yang disebabkan oleh bergantung pada ketepatan atau kebolehpercayaan maklumat terjemahan di tapak web; kandungan dalam teks terjemahan hanya mewakili pandangan pengarang asal dan tidak mewakili pandangan dan pendapat platform. Ia tidak ada kena mengena dengan kedudukan pembangun platform.',
        statementThree: '3. Fungsi pembacaan pruf tatabahasa hanya membaca pruf berdasarkan isu linguistik dan tatabahasa kandungan dan tidak boleh mencapai tahap penggilap bahasa buatan. Platform tidak bertanggungjawab untuk sebarang kerugian yang disebabkan oleh terlalu bergantung pada hasil pembacaan pruf tatabahasa.',
        statementFour: '4. Jika pembaca menghantar artikel kepada penerbitan berdasarkan keputusan pengesyoran persamaan, mereka mesti mengesahkan semula maklumat isu dan menghubungi jabatan editorial sebelum menyerahkan. Kami tidak bertanggungjawab ke atas sebarang kerugian yang disebabkan oleh pergantungan buta terhadap maklumat yang disediakan oleh laman web.',
        statementFive: '5. Pendapat yang dinyatakan dalam soalan, keperluan carian, teks dan fail yang dimuat naik oleh pembaca tidak mewakili pandangan dan pendapat platform, dan tiada kaitan dengan kedudukan pembangun platform.',
        // 手机端
        statementOneMobile: '1. Kandungan balasan ChatAnswer adalah berdasarkan jawapan kepada soalan lazim dan maklumat awam tentang sumber berkaitan. Kandungan sebenar tertakluk kepada maklumat rasmi perpustakaan dan kandungan sumber sumber rasmi.',
        statementTwoMobile: '2. Hasil terjemahan fungsi terjemahan adalah untuk rujukan sahaja. Platform tidak bertanggungjawab untuk sebarang kerugian yang disebabkan oleh bergantung pada ketepatan atau kebolehpercayaan maklumat terjemahan di tapak web; kandungan dalam teks terjemahan hanya mewakili pandangan pengarang asal dan tidak mewakili pandangan dan pendapat platform. Ia tidak ada kena mengena dengan kedudukan pembangun platform.',
        statementThreeMobile: '3. Fungsi pembacaan pruf tatabahasa hanya membaca pruf berdasarkan isu tatabahasa linguistik kandungan dan tidak boleh mencapai tahap penggilap bahasa tiruan. Platform tidak bertanggungjawab terhadap sebarang kerugian yang disebabkan oleh terlalu bergantung pada hasil pembacaan pruf tatabahasa.',
        statementFourMobile: '4. Jika pembaca menghantar artikel kepada penerbitan berdasarkan keputusan pengesyoran persamaan, mereka perlu mengesahkan semula maklumat jurnal dan menghubungi jabatan editorial sebelum menyerahkan. Kami tidak bertanggungjawab ke atas sebarang kerugian yang disebabkan oleh pergantungan buta terhadap maklumat yang diberikan oleh laman web.',
        statementFiveMobile: '5. Pendapat yang dinyatakan dalam soalan, keperluan carian, teks dan fail yang dimuat naik oleh pembaca tidak mewakili pandangan dan pendapat platform, dan tiada kaitan dengan kedudukan pembangun platform.',

        // 进入弹窗文本
        hellow: 'Hello: Selamat datang perundingan anda, saya',
        introduceOne: 'Pembantu AI Pintar ChatAnswer gembira untuk melayani anda.',
        introduceTwo: '1. Waktu buka perpustakaan',
        introduceThree: '2. Bagaimana untuk mencari sumber digital?',
        introduceFour: '3. Apakah yang perlu saya lakukan sekiranya buku yang dipinjam hilang secara tidak sengaja?',
        introduceFive: '4. Memperkenalkan pangkalan data berkaitan perubatan',
        introduceSix: '5. Bagaimanakah saya boleh mengakses sumber digital perpustakaan di luar kampus?',
        introduceSeven: 'Anda boleh bertanya kepada saya soalan tentang perpustakaan, sebagai contoh, anda boleh bertanya kepada saya "Bagaimana untuk menyemak dan mencari buku yang anda perlukan?" "Waktu buka perpustakaan" "Peraturan peminjaman buku", dll. Saya akan cuba sedaya upaya untuk menjawab anda; dan tentang Kami juga boleh menjawab soalan tentang buku, pangkalan data dan perkhidmatan perpustakaan lain, seperti:',
        questions:'Soalan selanjutnya',
        Continue:'Teruskan',
        recording:'Rakaman klik tetikus',
        stopRecording:'Klik tetikus untuk menghentikan rakaman',
        microphone:'Sila benarkan halaman ini menggunakan mikrofon dahulu',
        browserTips:'Penyemak imbas anda tidak menyokong pengecaman pertuturan',
        browserTips2:'Penyemak imbas anda tidak menyokong pengecaman kelantangan bunyi',
        progress:'Pengecaman pertuturan sedang berjalan...',
        failed:'Pengecaman suara gagal',
    },
    chatresearch: {
        theme: 'ChatResearch | Penemuan mendalam berasaskan semantik',
        themeMobile: 'Penemuan mendalam berasaskan semantik',
        switchSemantics: 'Tukar carian semantik',
        switchTraditional: 'Beralih kepada carian tradisional',
        title: 'tajuk',
        results:'Hasil pilihan',
        source: 'sumber',
        year: 'tahun penerbitan',
        abstract: 'Ringkasan',
        tips: 'Sila masukkan kandungan carian...',
        select:'sila pilih',
        issn: 'ISSN',
        introduce_tit: 'Pengenalan Platform',
        introduceOne: 'ChatResearch akan menggunakan kecerdasan buatan dan teknologi canggih untuk menyediakan pembaca dengan platform penyelidikan akademik yang lebih komprehensif, diperibadikan dan cekap. Ciri teras termasuk:',
        introduceTwo:'Sistem carian semantik merentas bahasa: Melalui pemahaman mendalam tentang niat dan minat carian pembaca, serta graf pengetahuan merentas bahasa, sistem carian semantik silang bahasa platform ChatResearch akan menyediakan hasil carian yang lebih komprehensif dan tepat.',
        introduceThree: 'Pengurusan dokumen kelompok: Alat pengurusan dokumen kelompok boleh membantu penyelidik, sarjana dan kumpulan lain dengan cepat memproses sejumlah besar kandungan dokumen. Mereka boleh melaksanakan klasifikasi, anotasi, carian, penapisan, anotasi, muat turun dan pelbagai fungsi automatik, sekali gus meningkatkan kecekapan pengurusan dokumen dan penyelidikan saintifik.',
        search:'Carian logik tradisional',
        searchAll:'Cari semua',
        searchTip:'Anda boleh menggunakan teks penuh abstrak, perenggan daripada literatur atau teks huraian terperinci sebagai kandungan carian. Sistem boleh melaksanakan perolehan semula semantik berdasarkan perbandingan persamaan semantik. Semakin panjang kandungan input, semakin tepat kesan padanan.',
        clear:'Kosongkan carian',
        link:'pautan artikel',
        Similar:'Dokumen yang serupa',
        followingresults:'Cari hasil berikut',
        chinese:'cina',
        english:'Inggeris',
        total:'Kembalikan jumlah bilangan keputusan',
        introduceFour:'Sistem penemuan subjek berdasarkan analisis semantik dan padanan persamaan, yang boleh mencapai perolehan semula yang cekap dan pintar merentas bahasa.',
        volume:'Sila pilih volum carian',
       
        inputTips:'Kandungan kotak input semasa tidak boleh kosong!'
    },
    chatlanguage: {
        enter: 'Masuk',
        errorChecking: 'Cari kesalahan tatabahasa dalam bahasa Inggeris',
        CToE: 'Cina kepada Inggeris',
        EToC: 'Inggeris kepada Cina',
        docTran: 'Terjemahan dokumen terjemahan',
        functionIntroduction: 'Ciri-ciri',
        introduceOne: 'Anda boleh menggunakan fungsi "Cari Ralat Tatabahasa Bahasa Inggeris" untuk melaksanakan pembacaan pruf tatabahasa yang bijak bagi kandungan teks bahasa Inggeris. Selepas memasukkan kandungan, sistem boleh mengenal pasti dan membetulkan masalah tatabahasa dalam kertas dengan bijak. Ia menyokong pembetulan struktur ayat, tegang, penggunaan subjek dan predikat, tanda baca dan jenis masalah lain, membantu meningkatkan kualiti artikel dan meningkatkan kebolehbacaan dan ketepatan ungkapan.',
        introduceTwo:'Anda boleh menggunakan fungsi "Penggilapan Akademik Bahasa Inggeris" untuk menggilap dan mengoptimumkan teks Bahasa Inggeris. Sistem akan mengubah suai teks dari perspektif kelancaran dan keanggunan untuk menjadikannya lebih lancar dan ringkas. Tambahkan daya tarikan profesional pada teks dan jadikan idea tema kelihatan lebih jelas.',
        tips: 'Sila masukkan kandungan pertanyaan',
        basic:'Fungsi asas',
        polish:'Penggilap akademik Inggeris',
        inputTips:'Sila masukkan kandungan teks yang memerlukan pembacaan pruf atau penggilap',
    },
    chatfellows:{
        introduceOne:'Platform Penemuan Pintar Pencapaian——Berdiri di atas bahu pendahulu',
        introduceTwo:'Pengenalan platform',
        introduceThree_one:'ChatFellows',
        introduceThree_two:'Hasil platform penemuan pintar ialah a',
        introduceThree:'Alat carian akademik pintar yang dicipta oleh penyelidik saintifik. Berdasarkan integrasi komprehensif keputusan institusi, pengiraan persamaan semantik, teknologi vektorisasi, persepsi bahasa semula jadi dan teknologi lain digunakan untuk mencapai penggunaan hasil yang mendalam dan berbilang dimensi, mencapai pemadanan keputusan yang bijak dan tepat, pengisihan persamaan, dan merealisasikan rentas -pendapatan dan Pemadanan bahasa, membantu penyelidik saintifik dengan berkesan dalam menjalankan penyelidikan saintifik dan kerja penulisan seperti penyelidikan kesusasteraan akademik, perolehan rujukan, dan pemilihan jurnal.',
        introduceFour:'Platform penemuan pintar hasil telah menyepadukan sepenuhnya dan mengumpulkan hasil penyelidikan utama sekolah kami. Melalui aplikasi mendalam teknologi AI pintar, hasilnya boleh digunakan dengan berkesan dan membantu dalam pembangunan kerja penyelidikan saintifik yang berkesan. Ia komited untuk membantu pengguna mencari kertas berkualiti tinggi dengan cepat dan tepat dalam bidang berkaitan, meningkatkan kecekapan penyelidikan dan membantu mencapai keputusan akademik. Berdiri di atas bahu gergasi dan terus mempromosikan kemajuan berterusan penyelidikan akademik.',
        introduceFive:'Fungsi teras',
        introduceSix:'Pendapatan padanan pintar: merealisasikan penemuan cekap kertas yang serupa dalam keputusan sumber penilaian penting sekolah kami.',
        introduceSeven:'Pengambilan semula silang bahasa: Melalui aplikasi teknologi vektorisasi, perolehan semula dan pemadanan direalisasikan tanpa sekatan bahasa.',
        introduceTen:'Pengisihan pengoptimuman persamaan: Hasil padanan optimum dibentangkan berdasarkan persamaan kertas kerja, memudahkan pembaca saintifik untuk mencari hasil penyelidikan yang paling relevan dengan cepat.',
        introduceEight:'Paparan maklumat terperinci: Platform ini menyediakan maklumat literatur terperinci hasil carian dan terjemahan ringkasan hasil bahasa asing, membolehkan pengguna memahami dengan cepat intipati hasil carian.',
        introduceNine:'Kemas kini yang sangat tepat pada masanya: Platform sentiasa menyegerakkan pangkalan data sumber penilaian penting untuk memastikan pembaca dapat memahami keputusan terkini.',
        knowBtn:'Saya faham',
        enter:'Masuk',
        title:'Platform Penemuan Pintar Pencapaian——Berdiri di atas bahu pendahulu',
        tips:'Sila masukkan abstrak atau topik artikel yang ingin anda cari (tajuk, kata kunci, dsb.), dan sistem akan membantu anda mencari kertas kerja serupa daripada sekolah kami dalam sumber penilaian utama (tiada terjemahan dan penukaran khas diperlukan untuk bahasa Cina !)',
        submit:'Serahkan',
        relatedLiterature:'Sastera berkaitan',
        year:'Tahun',

        enSummary:'Ringkasan bahasa Inggeris',
        cnSummary:'Ringkasan bahasa cina',
    },
    chatdocument:{
        title:'Alat penghuraian dokumen dalam',
        introduce:'Realisasikan pengekstrakan kandungan data dokumen dan analisis teks penuh topik dan skop tertentu, dengan itu membantu dalam penyelidikan yang mendalam.',
        start:'Mula mengalami',
        ask:'Tanya soalan tentang dokumentasi dan dapatkan jawapan yang anda perlukan',
        createSession:'Buat perbualan dan tanya soalan pada berbilang dokumen secara serentak',
        quoting:'Memetik petikan dan analisis mendalam tentang kandungan sastera',
        analyze:'Analisis carta dan ekstrak data untuk analisis komprehensif',
        tool:'Pembantu penghuraian dokumen yang sangat cekap',
        list:'Senarai sastera',
        conversation:'Senarai perbualan',
        createAsk:'Buat sesi',
        upload:'Fail dimuatnaik',
        drag:'Seret masuk fail atau klik untuk memuat naik',
        introduceOne:'Tanya soalan tentang kandungan dokumen dan dapatkan jawapan serta-merta melalui sembang.',
        introduceTwo:'ChatDocuments ialah pembantu penghuraian fail yang boleh mengekstrak, mencari dan meringkaskan maklumat daripada dokumen dengan cepat.',
        quick:'Akses cepat',
        enter:'Sila masukkan kandungan...',
        askQuestion:'Tanya soalan',
        example:'Contoh',
        busy:'Perkhidmatan sedang sibuk, sila cuba lagi',
        stop:'Berhenti menjawab',
        onlyAsk:'Hanya tanya soalan tentang artikel semasa',
        chapter:'Bab',
        create:'Cipta',
        editsession:'Sesi edit',
        sessionname:'Nama sesi',
        currentlyselected:'Dipilih pada masa ini',
        fileselection:'Pemilihan fail',
        revise:'Semak semula',
        docLanguage:'Bahasa dokumen',
        zhDoc:'Dokumentasi Cina',
        enDoc:'Dokumen bahasa Inggeris',
        support:'*Hanya menyokong memuat naik fail pdf',
        nowUpload:'Memuat naik, sila tunggu...',
        question:'Bahasa dokumen tidak sepadan dan tidak boleh dipilih',
        editTitle:'Klik dua kali untuk mengedit nama fail',

        uploadSuccess:'Muat naik berjaya',
        sideBar:'Kecilkan bar sisi',
        noData:'Tiada jadual parsable ditemui dalam dokumen',
        delConfirm:'Adakah anda pasti mahu memadamkan fail ini?',
        unable:'Tidak dapat menghuraikan excel',
        delSuccess:'Berjaya dipadamkan',
        selFile:'Sila pilih fail',
        inputName:'Sila masukkan nama sesi',
        createSuccess:'Dicipta dengan jayanya',
        fileTips:'Fail sedang ditukar, sila cuba sebentar lagi',
        failFile:'Penukaran fail gagal, sila muat naik semula',
        defaultQuestion1:'Apakah medan yang disertakan dalam jadual dan apakah data yang diterangkan?',
        defaultQuestion2:'Sila hitung purata setiap lajur data?',
        defaultQuestion3:'Sila hitung median setiap lajur data?',
        defaultQuestion4:'Nilai yang paling kerap muncul dalam setiap lajur data ialah？',
        defaultQuestion5:'Apakah maklumat yang boleh kita perolehi daripada data dalam jadual, dan apakah kesimpulan yang boleh kita buat daripada analisis?',
    },
    chatdata:{
        title:'Alat analisis pintar data mendalam',
        introduce:'Temui cerapan daripada data anda melalui penghuraian pintar dan analisis mendalam. Gunakan fungsi analisis visual untuk mencapai paparan yang jelas dalam bentuk carta.',
        start:'Mula mengalami',
        ask:'Tanya soalan tentang dokumentasi dan dapatkan jawapan yang anda perlukan',
        create:'Buat perbualan dan tanya soalan pada berbilang dokumen secara serentak',
        quoting:'Memetik petikan dan analisis mendalam tentang kandungan sastera',
        analyze:'Analisis carta dan ekstrak data untuk analisis komprehensif',
        tool:'Pembantu penghuraian dokumen yang sangat cekap',
        list:'Senarai sastera',
        conversation:'Senarai perbualan',
        createAsk:'Buat sesi',
        upload:'Fail dimuatnaik',
        drag:'Seret masuk fail atau klik untuk memuat naik',
        introduceOne:'ChatData membolehkan penyoalan perbualan dengan jadual melalui analisis pintar jadual dan set data. Dan melalui analisis yang mendalam, carta visual boleh dijana secara automatik untuk menjadikan data jelas sepintas lalu!',
       
        quick:'Akses cepat',
        enter:'Sila masukkan kandungan...',
        hint:'Petunjuk',
        hintOne:'Modul ini sedang dalam penyelenggaraan dan tidak tersedia buat sementara waktu. Terima kasih atas pemahaman dan kesabaran anda.',
        Isee:'Saya faham',
    },
    chatopen:{
        title:'Enjin penemuan pengetahuan terbuka anda',
        switch:'Beralih kepada carian tradisional',
        introduce:'Dapatkan dan temui hasil penyelidikan saintifik terkini dalam fizik, matematik, sains komputer, kecerdasan buatan, statistik, dsb., dan fahami trend pembangunan',
        features:'Ciri-ciri',
        featureOne:'Gunakan kecerdasan buatan dan teknologi canggih untuk menyediakan penyelidik saintifik pengalaman penemuan pengetahuan yang lebih cekap, berkuasa dan tepat. ChatOpen menggunakan teknologi perolehan semula semantik untuk mencapai pemahaman yang mendalam tentang niat carian, minat dan pemetaan merentas bahasa pembaca.',
        featureTwo:'Sepadukan metadata pengetahuan terbuka yang besar-besaran untuk menyediakan pembaca saintifik dengan pelbagai jenis hasil akademik sumber terbuka termasuk dokumen akses terbuka, pracetak, dll. Digabungkan dengan penemuan semantik, kami berharap sumber ini dapat membantu anda mempromosikan inovasi penyelidikan akademik dan menghubungkan anda dengan masa depan yang terbuka.',
        translate:'Menterjemah',
        clear:'Kosongkan penapis',
    },
    message:{
        authority: "Tiada kebenaran",
        upload: "Hanya format .jpg/.png yang disokong!",
        apply: "Permohonan percubaan telah dihantar, sila tunggu dengan sabar!",
        delete: "Adakah anda pasti mahu memadam fail ini?",
        size: "Saiz fail tidak boleh melebihi 20MB",
        wait: "Sedang diproses, sila tunggu"
    }
}
